export interface ScheduledContentState {
    currentDailyPauseUuid: string | null;
}

const defaultState: ScheduledContentState = {
    currentDailyPauseUuid: null,
};

export const scheduledContent = {
    state: defaultState,
    reducers: {
        setCurrentDailyPauseUuid: (
            state: ScheduledContentState,
            payload: string | null = null,
        ): ScheduledContentState => {
            state.currentDailyPauseUuid = payload;

            return state;
        },
    },
};
